import { IconProps } from "@models/types";

export function UserIcon({ className, width, height }: IconProps) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <g id="Group_1084" data-name="Group 1084">
          <g id="Subtraction_2" data-name="Subtraction 2">
            <path d="M18.64,18.76a8.85,8.85,0,0,0-1.72-3.93,8.74,8.74,0,0,0-3.47-2.71A4.35,4.35,0,0,1,10,13.74a4.32,4.32,0,0,1-3.44-1.63,8.64,8.64,0,0,0-3.49,2.71,8.79,8.79,0,0,0-1.73,3.94H18.64m1.08,1H.28A9.82,9.82,0,0,1,7,10.91a3.24,3.24,0,0,0,3,1.85,3.23,3.23,0,0,0,3-1.84,9.7,9.7,0,0,1,4.66,3.31,9.81,9.81,0,0,1,2,5.51Z" />
          </g>
          <g id="Ellipse_71" data-name="Ellipse 71">
            <ellipse
              style={{ fill: "none" }}
              cx="10.02"
              cy="5.58"
              rx="4.87"
              ry="5.31"
            />
            <path d="M10,10.89A5.11,5.11,0,0,1,5.15,5.58,5.11,5.11,0,0,1,10,.26a5.12,5.12,0,0,1,4.87,5.32A5.12,5.12,0,0,1,10,10.89Zm0-9.65a4.14,4.14,0,0,0-3.9,4.34A4.14,4.14,0,0,0,10,9.91a4.14,4.14,0,0,0,3.9-4.33A4.14,4.14,0,0,0,10,1.24Z" />
          </g>
        </g>
      </svg>
    </>
  );
}
